import { render, staticRenderFns } from "./background_question.vue?vue&type=template&id=8bc0dc80&"
import script from "./background_question.vue?vue&type=script&lang=js&"
export * from "./background_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports